<template>
	<div class="ion-page" >
    <nav-bar v-if="UserType < 4" :userTypeName="EstamosEn(UserType)" :headerName=" 'Sol. pendientes en ' + $route.params.tipo"/>
    <ion-content>
      <div v-if=" $route.params.tipo == 'ADMS' ">
        <ot-solicitudes :readOnly="1" />
      </div>
      
      <div v-else-if="UserType == 2">
        {{ $route.params.tipo }}
      </div>

      <div v-else-if=" $route.params.tipo == 'OP' ">
        <admin-sol :readOnly="1"/>
      </div>

    </ion-content>

  </div>
</template>

<script>
// import UsrSol from './UsrSolicitudes.vue'
import AdminSol from './AdminSolicitudes.vue'
import OtSolicitudes from './OtSolicitudes.vue'
import NavBar from '../components/NavBar.vue'

import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: "solicitudesStatus",
  components: { NavBar , OtSolicitudes, AdminSol },
  data() {
    return {
      UserType:4,
      info: null
    };
  },
  methods: {
    EstamosEn(vale){ 
      let _x = "none";
      switch (vale) {
        case 1:
          _x = "OP"
          break;
        case 2:
          _x = "USR"
          break;
        case 3:
          _x = "ADMS";
          break;
        default:
          break;
      }
      return _x;
     },
    openStart () {
      document.querySelector('ion-menu-controller').open();
      document.querySelector('ion-menu').open('my-menu');
      // console.log("Erroro");
    },
    // async getZipInfo(zip) {
    //   const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
    //   if (res.status == 404) {
    //     this.showAlert();
    //   }
    //   this.info = await res.json();
    // },
    // clearInfo() {
    //   this.info = null;
    // },
    showAlert() {
      return this.$ionic.alertController
        .create({
          header: "Not Valid",
          message: "Please enter a valid US zipcode",
          buttons: ["OK"]
        })
        .then(a => a.present());
    },
    reRedirect(stringROL){
      if(  stringROL == "1ib87WwHClPfwbCJS8BB") // Operaciones ROL
        this.UserType = 1;// this.$router.replace('/solicitudes')
      else if( stringROL == "jcwXkDPT9SzhJJd179Sr") // USR GRAL ROL
        this.UserType = 2 // this.$router.replace('/solicitudes')
      else if( stringROL == "kBfoI8B7NUvsy33nA2VB") // USR ADMS
        this.UserType = 3; // this.$router.replace('/solicitudes-admin')
      else
        this.$router.replace("/login")
    },
  },
  created (){
    let _self = this;
    // console.log("Inciado  . . .");
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // _self.UserType = 3;
        let _info = _self.$storage.get("user-info");
        // console.log(_info.rol);
        if( _info == null )
          return;
        setTimeout( ()=> {
          // console.log(_info)
          _self.reRedirect(_info.rol);
        } , 1500);
        // console.log("Existe USUARIO . . . => ", _info);

      } else {
        setTimeout( ()=> {
          _self.UserType = 4;
          _self.$storage.remove("user-info");
          _self.$router.replace('/login');
        },800);
        // console.log("No Existe usuario . . . ")
      }
    });
    // const currentUser = firebase.auth().currentUser;

  }
};
</script>
<style lang="scss" scoped>
  .loading {
    position: fixed;
    background-color:#54595f;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:10000 !important;
  }
  .loading .lds-cube {
    position: relative;
  }
  .loading .lds-cube div {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 10px;
    left: 10px;
    background: #cde343;
    -webkit-animation: lds-cube 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    animation: lds-cube 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
  }
  .loading .lds-cube div:nth-child(2) {
    top: 10px;
    left: 110px;
    background: #0274be;
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
  }
  .loading .lds-cube div:nth-child(3) {
    top: 110px;
    left: 110px;
    background: #fff;
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
  }
  .loading .lds-cube div:nth-child(4) {
    top: 110px;
    left: 10px;
    background: #ffb646;
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
  }
  .loading .lds-cube {
    width: 200px !important;
    height: 200px !important;
    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  }
  @keyframes lds-cube {
    0% {
      -webkit-transform: scale(1.5);
      transform: scale(1.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @-webkit-keyframes lds-cube {
    0% {
      -webkit-transform: scale(1.5);
      transform: scale(1.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

</style>